const leftSideLink = [
	{ path: "menu", name: "MENU" },
	{ path: "rewards", name: "REWARDS" },
	{ path: "gift", name: "GIFT CARDS" },
];

const signInLink = [
	{ path: "sign-in", name: "Sign in" },
	{ path: "join-now", name: "Join Now" },
];

const findStore = [{ path: "find-store", name: "Find a Store" }];

const navContent = { leftSideLink, signInLink, findStore };

export default navContent;
